// extracted by mini-css-extract-plugin
module.exports = {"videotrackcontainer":"videochapters_videotrackcontainer__1Ykrg","current":"videochapters_current__1NfsK"};